export default {
	// api请求地址
	baseUrl: 'https://book.v5k5.com',
	
	// 图片域名
	imgDomain: 'https://book.v5k5.com',
	
	// 前端域名
	webDomain: 'https://book.v5k5.com/web',
	
	// 腾讯地图key
	mpKey: 'IZQBZ-3UHEU-WTCVD-2464U-I5N4V-ZFFU3',
	
	// 客服
	webSocket: 'wss://book.v5k5.com/wss',
	
	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500
}